/**
 * Checks if a given date is within the last 24 hours from now
 * @param dateString - ISO date string to check
 * @returns true if the date is within 24 hours, false otherwise
 */
export const isWithin24Hours = (dateString: string | null | undefined): boolean => {
  if (!dateString) {
    return false;
  }

  try {
    const targetDate = new Date(dateString);
    const now = new Date();
    const twentyFourHoursInMs = 24 * 60 * 60 * 1000;
    const timeDifference = now.getTime() - targetDate.getTime();

    return timeDifference >= 0 && timeDifference <= twentyFourHoursInMs;
  } catch {
    return false;
  }
};
